<template>
  <div>
    <el-card class="ele-card">
      <div>
          <h4 class="label">弹窗广告位标题</h4>
          <el-input size="mini" style="width:300px;" placeholder="请输入" v-model="pageInfo.title"></el-input>
      </div>
      <div>
        <h4 class="label">排序号</h4>
        <el-input type="number" size="mini" style="width:300px;" placeholder="请输入" v-model="pageInfo.sort"></el-input>
      </div>
      <div>
        <h4 class="label">开放时间: </h4>
        <div class="control">
          <span class="inline-block">
            <el-date-picker
              v-model="pageInfo.startTime"
              type="datetime"
              placeholder="开始时间"
              align="right" size="small"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </span>
          <span class="">~</span>
          <span class="inline-block">
            <el-date-picker
              v-model="pageInfo.endTime"
              type="datetime"
              placeholder="结束时间"
              align="right" size="small"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </span>
        </div>
      </div>
      <div>
        <h4 class="label">用户分群</h4>
        <el-checkbox-group v-model="pageInfo.userTypes">
          <el-checkbox :label="0">未付费用户可见</el-checkbox>
          <el-checkbox :label="1">已付费用户可见</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="margin-top">
          <h4 class="label">添加图片</h4>
          <!-- 上传图片 -->
          <div class="button-wrap">
              <span class="button is-primary" id="js_hotImageUploadBtn">上传图片</span>
              <span><span class='red'>【分类】建议尺寸：326*160px</span> 只能上传 jpg/png 文件，且不超过 1MB</span>
          </div>
          <!-- 图片预览 -->
          <div v-show="pageInfo.image.image">
              <image-component :image="imgShow.image" :width="imgShow.width" :height="imgShow.height"></image-component>
          </div>
      </div>
      <div>
          <h4 class="label">编辑链接</h4>
          <custom-link :link='pageInfo.link' @update:link="val => { pageInfo.link = val }"></custom-link>
      </div>
    </el-card>
    <div class='foot'>
        <button class='button is-primary' @click='ensure()'>保存</button>
        <button class='button' @click='cancel()'>返回</button>
    </div>
  </div>
</template>

<script>
import Uploader from 'COMMON/uploaderModule/uploader'
import CustomLink from 'COMMON/DefinedLink'
export default {
  components: {
    CustomLink
  },
  data () {
    return {
      pageInfo: {
        bannerId: 0,
        title: '',
        userTypes: [0, 1],
        startTime: null,
        endTime: null,
        image: {
          image: '',
          width: 0,
          height: 0
        },
        sort: 0,
        link: '' // 链接地址
      },
      imgShow: {}
    }
  },
  watch: {
    'pageInfo.image.image' () {
      let width = this.pageInfo.image.width > 300 ? 300 : this.pageInfo.image.width
      let height = this.pageInfo.image.width > 300 ? width / (this.pageInfo.image.width / this.pageInfo.image.height) : this.pageInfo.image.height
      this.imgShow = {
        image: this.pageInfo.image.image,
        width: width,
        height: height
      }
    }
  },
  mounted () {
    if (this.$route.query.bannerId) {
      this.getAdvInfo(this.$route.query.bannerId)
    } else {
      this.getAdvInfo(0)
    }
    this.uploadMainBind()
  },
  methods: {
    // 获取广告位
    getAdvInfo (bannerId) {
      let params = {
        bannerId: bannerId
      }
      HttpRequest.get('/admin.php?method=main.getAdv', params).then((response) => {
        if (response.result === 0) {
          let data = response.data
          if (bannerId == 0) {
            this.pageInfo.sort = parseInt(data.maxSort)
          } else {
            this.pageInfo.link = data.link
            this.pageInfo.bannerId = data.bannerId
            this.pageInfo.endTime = data.endTime
            this.pageInfo.startTime = data.startTime
            this.pageInfo.title = data.title
            this.pageInfo.image.image = data.image.image
            this.pageInfo.image.width = data.image.width
            this.pageInfo.image.height = data.image.height
            this.pageInfo.sort = data.sort
            this.pageInfo.userTypes = data.userTypes
          }
        }
      })
    },
    // 上传图片
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_hotImageUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image'
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.pageInfo.image.image = response.data.images.info.path
            this.pageInfo.image.width = response.data.images.info.width
            this.pageInfo.image.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },

    ensure () {
      this.pageInfo.sort = parseFloat(this.pageInfo.sort)
      let params = Object.assign({}, this.pageInfo)
      params.status = 2
      HttpRequest.post('/admin.php?method=main.doSaveAdv', params).then((response) => {
        if (response.result === 0) {
          this.$message('保存成功')
          this.cancel()
        } else {
          this.$message(response.msg)
        }
      })
    },
    // 取消跳转
    cancel () {
      this.$router.push({
        name: 'cyzsIndexPopAd',
        query: {
          page: this.$route.query.page,
          pageSize: this.$route.query.pageSize
        }
      })
    }

  }
}
</script>

<style scoped lang="less">
.button-wrap {
    margin: 10px 0;
    line-height: 32px;
    .img-wrap {
        margin: 10px 0;
    }
}
.foot {
  margin: 20px 0 50px;
  text-align: center;
}
</style>
